declare global {
  interface Window {
    mdChatClient?: string
    movideskChatWidgetChangeWindowState?: (state: 'maximized' | 'minimized') => void
  }
}

const MOVIDESK_CLIENT_SCRIPT_ID = 'movidesk-chat-client'
const MOVIDESK_WIDGET_SCRIPT_ID = 'movidesk-chat-widget'
const MOVIDESK_SCRIPT_SRC = 'https://chat.movidesk.com/Scripts/chat-widget.min.js'

export function isMovideskChatInjected (): boolean {
  return document.getElementById(MOVIDESK_WIDGET_SCRIPT_ID) !== null
}

export function injectMovideskChat (chatCode?: string): void {
  if (!chatCode || isMovideskChatInjected()) {
    return
  }

  window.mdChatClient = chatCode

  const clientScript = document.createElement('script')
  clientScript.id = MOVIDESK_CLIENT_SCRIPT_ID
  clientScript.textContent = `var mdChatClient="${chatCode}";`
  document.body.appendChild(clientScript)

  const widgetScript = document.createElement('script')
  widgetScript.id = MOVIDESK_WIDGET_SCRIPT_ID
  widgetScript.async = true
  widgetScript.src = MOVIDESK_SCRIPT_SRC
  document.body.appendChild(widgetScript)
}

export function removeMovideskChat (): void {
  document.getElementById(MOVIDESK_CLIENT_SCRIPT_ID)?.remove()
  document.getElementById(MOVIDESK_WIDGET_SCRIPT_ID)?.remove()
  document.getElementById('md-app-widget')?.remove()

  if (window.mdChatClient) {
    delete window.mdChatClient
  }

  if (window.movideskChatWidgetChangeWindowState) {
    delete window.movideskChatWidgetChangeWindowState
  }
}

export function openMovideskChat (): void {
  if (typeof window.movideskChatWidgetChangeWindowState === 'function') {
    window.movideskChatWidgetChangeWindowState('maximized')
  }
}
